define.alias("shared/components/shared/feature-upgrade-banner", "media/components/shared/feature-upgrade-banner");